import Mentor from './Mentor';

export default Mentor;